export default __webpack_public_path__ + "static/media/type_6_5.db9baa72.svg";